var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2834_20361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 15C29.9999 23.2824 23.2837 29.9976 14.9963 29.9988C6.71501 29.9988 -0.00126058 23.2824 -6.03919e-05 14.9988C-0.00246078 6.7152 6.71381 0 14.9987 0C23.2837 0 29.9999 6.7164 29.9999 15Z",
    fill: "#B11733",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7333 20.7499C10.3917 20.7499 10.1083 20.4666 10.1083 20.1249V18.3999C10.1083 18.0582 10.3917 17.7749 10.7333 17.7749C11.075 17.7749 11.3583 18.0582 11.3583 18.3999V20.1249C11.3583 20.4749 11.075 20.7499 10.7333 20.7499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20.7498C14.6583 20.7498 14.375 20.4665 14.375 20.1248V16.6665C14.375 16.3248 14.6583 16.0415 15 16.0415C15.3417 16.0415 15.625 16.3248 15.625 16.6665V20.1248C15.625 20.4748 15.3417 20.7498 15 20.7498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2667 20.7502C18.925 20.7502 18.6417 20.4669 18.6417 20.1252V14.9419C18.6417 14.6002 18.925 14.3169 19.2667 14.3169C19.6083 14.3169 19.8917 14.6002 19.8917 14.9419V20.1252C19.8917 20.4752 19.6167 20.7502 19.2667 20.7502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7333 15.9832C10.45 15.9832 10.2 15.7915 10.125 15.5082C10.0417 15.1749 10.2417 14.8332 10.5833 14.7499C13.65 13.9832 16.35 12.3082 18.4083 9.91652L18.7917 9.46652C19.0167 9.20819 19.4083 9.17485 19.675 9.39985C19.9333 9.62485 19.9667 10.0165 19.7417 10.2832L19.3583 10.7332C17.1333 13.3332 14.2 15.1415 10.8833 15.9665C10.8333 15.9832 10.7833 15.9832 10.7333 15.9832Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2667 12.9333C18.925 12.9333 18.6417 12.65 18.6417 12.3083V10.5H16.825C16.4833 10.5 16.2 10.2167 16.2 9.875C16.2 9.53333 16.4833 9.25 16.825 9.25H19.2667C19.6083 9.25 19.8917 9.53333 19.8917 9.875V12.3167C19.8917 12.6583 19.6167 12.9333 19.2667 12.9333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.9582H12.5C7.97501 23.9582 6.04167 22.0248 6.04167 17.4998V12.4998C6.04167 7.97484 7.97501 6.0415 12.5 6.0415H17.5C22.025 6.0415 23.9583 7.97484 23.9583 12.4998V17.4998C23.9583 22.0248 22.025 23.9582 17.5 23.9582ZM12.5 7.2915C8.65834 7.2915 7.29167 8.65817 7.29167 12.4998V17.4998C7.29167 21.3415 8.65834 22.7082 12.5 22.7082H17.5C21.3417 22.7082 22.7083 21.3415 22.7083 17.4998V12.4998C22.7083 8.65817 21.3417 7.2915 17.5 7.2915H12.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2834_20361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/investment.b8df693095c0f0183b9ec0df18912559.svg";
export { ForwardRef as ReactComponent };